<template>
  <button
    :disabled="buttonDisabled"
    :type="nativeType"
    :class="[
      btnClass,
      type ? `rc-button--${type}` :'',
      size ?`rc-button--${size}`:''
    ]"
    class="rc-button"
    @click="onClick"
  >
    <rc-loading
      v-if="loading"
      :color="type === 'default' || plain ? 'black' : 'white'"
      type="spinner"
      size="15px" />
    <i v-if="icon && !loading" :class="icon "/>
    <span class="rc-button__text">
      <slot />
    </span>
  </button>
</template>
<script>
  export default{
    name: 'RcButton',
    props: {
      // 文本
      text: String,
      // 是否是朴素按钮
      plain: Boolean,
      // 加载状态
      loading: Boolean,
      // 禁用状态
      disabled: Boolean,
      // 是否圆角按钮
      round: Boolean,
      // 是否圆形按钮
      circle: Boolean,
      // 图标类名
      icon: String,
      // 原生type属性
      nativeType: String,
      // 类型
      type: {
        type: String,
        default: 'default'
      },
      // 尺寸
      size: String
    },
    computed: {
      btnClass () {
        return {
          'is-plain': this.plain,
          'is-disabled': this.buttonDisabled,
          'is-round': this.round,
          'is-circle': this.circle,
          'is-loading': this.loading || this.icon
        }
      },
      buttonDisabled () {
        return this.disabled || this.loading
      }
    },
    methods: {
      onClick (event) {
        if (!this.loading && !this.disabled) {
          this.$emit('click', event)
        }
      }
    }
  }
</script>
<style lang="scss">
  /* stylelint-disable scss/no-global-function-names */
  @import "scss/mixins/button";

  @include b(button) {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: $color-white;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-text-size-adjust: 100%;

    @include button-size(12px, 20px, 14px, 3px);

    &:hover,
    &:focus {
      color: $color-primary;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }

    &:active {
      color: mix($color-black, $color-primary, 10%);
      border-color: mix($color-black, $color-primary, 10%);
      outline: none;
    }

    &::-moz-focus-inner {
      border: 0;
    }

    @include when (plain) {
      &:hover,
      &:focus {
        background: $color-white;
        border-color: $color-primary;
        color: $color-primary;
      }

      &:active {
        background: $color-white;
        border-color: mix($color-black, $color-primary, 10%);
        color: mix($color-black, $color-primary, 10%);
        outline: none;
      }
    }

    @include when(disabled) {
      &,
      &:hover,
      &:focus {
        color: $button-disabled-color;
        cursor: not-allowed;
        background-image: none;
        background-color: $button-disabled-fill;
        border-color: $button-disabled-border;
      }

      &.is-plain {
        &,
        &:hover,
        &:focus {
          background-color: $color-white;
          border-color: $button-disabled-border;
          color: $button-disabled-color;
        }
      }
    }

    @include when(loading) {
      i {
        display: inline-block;
        vertical-align: middle;
      }

      span {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        padding-left: 5px;
      }

      &:hover,
      &:focus {
        color: $color-primary;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }

    @include when(round) {
      border-radius: 20px;
      padding: 12px 23px;
    }

    @include when(circle) {
      border-radius: 50%;
      padding: $button-padding-vertical;
    }

    @include m(primary) {
      @include button-variant($button-primary-color, $button-primary-fill, $button-primary-border);
    }

    @include m(success) {
      @include button-variant($button-success-color, $button-success-fill, $button-success-border);
    }

    @include m(warning) {
      @include button-variant($button-warning-color, $button-warning-fill, $button-warning-border);
    }

    @include m(danger) {
      @include button-variant($button-danger-color, $button-danger-fill, $button-danger-border);
    }

    @include m(info) {
      @include button-variant($button-info-color, $button-info-fill, $button-info-border);
    }

    @include m(large) {
      @include button-size($button-large-padding-vertical, $button-large-padding-horizontal, $button-large-font-size, $button-large-border-radius);

      @include when(circle) {
        padding: $button-large-padding-vertical;
      }
    }

    @include m(medium) {
      @include button-size($button-medium-padding-vertical, $button-medium-padding-horizontal, $button-medium-font-size, $button-medium-border-radius);

      @include when(circle) {
        padding: $button-medium-padding-vertical;
      }
    }

    @include m(small) {
      @include button-size($button-small-padding-vertical, $button-small-padding-horizontal, $button-small-font-size, $button-small-border-radius);

      @include when(circle) {
        padding: $button-small-padding-vertical;
      }
    }
  }
</style>
